import {Box, Grid} from '@mui/material';
import React from 'react';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {useAccountContext} from '../../../contexts/AccountContext';
import GoalsSelect from '../../../components/Common/RecommendGoalsSelect';
import RecommendPlanOptions from './RecommendPlanOptions/RecommendPlanOptions';
import RecommendWhatOptions from './RecommendWhatOptions/RecommendWhatOptions';
import RecommendWhenOptions from './RecommendWhenOptions/RecommendWhenOptions';
import RecommendWhoOptions from './RecommendWhoOptions/RecommendWhoOptions';
import {recommendFieldsType} from './recommendFields';
import {RecommendSPPOptions} from './RecommendHowOptions/RecommendSPPOptions';
import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {HEADER_PLAN_LABELS} from './CreateRecommendHelpers';

export const CreateRecommendSPPDAHeader: React.FC = () => {
  const {values, isSubmitting} = useAutoForm<recommendFieldsType>();
  const {account} = useAccountContext();
  const contacts = account?.contacts || [];
  const whatVisible = !!values.contact;
  const planActionVisible =
    whatVisible &&
    !!values.planAction &&
    values.planAction !== OVRecommendActionEnum.ACTION;

  return (
    <Box
      bgcolor="white"
      borderRadius="8px"
      paddingLeft={2.5}
      paddingRight={2.5}
      paddingTop={1.5}
      paddingBottom={1.5}
    >
      <Grid
        container
        direction="row"
        alignContent="flex-start"
        justifyContent="flex-start"
        spacing={5}
      >
        <Grid item>
          <RecommendSPPOptions isSubmitting={isSubmitting} />
        </Grid>
        <Grid item>
          <RecommendWhoOptions
            key={`${values.how}-${values.sppType}`} // component re-renders when dependency changes
            isSubmitting={isSubmitting}
            visible
            contacts={contacts}
          />
        </Grid>
        <Grid item>
          <RecommendWhatOptions
            key={`${values.contact}-${values.sppType}`} // component re-renders when dependencies change
            visible={whatVisible}
          />
        </Grid>
        {planActionVisible && (
          <Grid item>
            <RecommendPlanOptions
              // loading={potsLoading}
              key={`${values.contact}-${values.sppType}-${values.planAction}`} // component re-renders when dependencies change
              isSubmitting={isSubmitting}
            />
          </Grid>
        )}
        {values.planAction ? (
          <Grid item>
            <GoalsSelect
              key={values.contact} // component re-renders when dependency changes
            />
          </Grid>
        ) : null}
        {!!values.contact &&
        !!values.how &&
        !!values.planAction &&
        !!values.mainPlanType ? (
          <Grid item>
            <RecommendWhenOptions
              key={values.contact} // component re-renders when dependency changes
              visible={
                !!values.contact &&
                !!values.how &&
                !!values.planAction &&
                !!values.mainPlanType
              }
            />
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};
